import React from "react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { CurrencyNote } from "../CurrencyNote";
import { TrustRow } from "../TrustRow";
import { IconByName } from "../IconByName";
import { heroTopics, images } from "../../data/content";
import { useOfferClock } from "../../hooks/useOfferClock";
export function Hero() {
  const {
    display
  } = useOfferClock();
  return <header className="bg-navy-950 text-white" data-id="element-192" data-mp="mszb8d4mep8o">
      <div className="bg-alert px-4 py-2.5 text-center text-[13px] font-extrabold uppercase tracking-wide" data-id="element-193" data-mp="ms7qxygh4dxp">
        Special launch offer · ends in <span className="tabular-nums" data-id="element-194" data-mp="vm2ke988gfxi">{display}</span>
      </div>

      <div className="mx-auto grid max-w-6xl gap-8 px-5 pb-16 pt-8 lg:grid-cols-2 lg:items-center lg:gap-x-14 lg:pt-16" data-id="element-195" data-mp="voouafilj7iw">
        <div data-id="element-196" data-mp="15l1vdygh0nno">
          <p className="font-display text-sm font-black uppercase tracking-wide text-white" data-id="element-197" data-mp="15lbed233lujv">
            Dental Bleaching Blueprint™ <span className="font-bold text-white/60" data-id="element-198" data-mp="1ak4pwoytrbhe">· By Dr. Valerica Montes</span>
          </p>
          <p className="mt-5 inline-block rounded-lg bg-brand px-3 py-1.5 text-[12px] font-extrabold uppercase tracking-wide text-navy-950" data-id="element-199" data-mp="9pduvoq0c4fr">
            The clinical blueprint for professional teeth whitening
          </p>
          <h1 className="mt-4 font-display text-[34px] font-black leading-[1.05] tracking-tight [text-wrap:balance] sm:text-5xl lg:text-[54px]" data-id="element-200" data-mp="3vx3ph3p69pa7">
            Stop Guessing Your Whitening Protocols.{" "}
            <span className="text-brand-light" data-id="element-201" data-mp="sgeumeyyc40d">Start Making More Confident Clinical Decisions.</span>
          </h1>
          <p className="mt-5 text-[17px] leading-relaxed text-white/80" data-id="element-202" data-mp="iohd6qhcoft7">
            Discover a structured clinical approach to professional teeth whitening — from patient assessment and shade evaluation to
            bleaching techniques, sensitivity management, and long-term maintenance.
          </p>
          <p className="mt-3 hidden text-[17px] leading-relaxed text-white/80 lg:block" data-id="element-203" data-mp="16ebq181o64dg">
            Learn how to identify the right candidates, recognize common mistakes, and manage challenging discoloration cases with greater
            clinical confidence.
          </p>
        </div>

        <div className="-mx-2 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mx-0" data-id="element-204" data-mp="2qw43zeiiy5v3">
          <img src={images.mockup} alt="Dental Bleaching Blueprint — 6 clinical volumes and 5 bonus guides" className="mx-auto w-full max-w-[560px]" data-id="element-205" data-mp="2qu1fiyx0sksh" />
        </div>

        <div data-id="element-206" data-mp="2hxsczbdqx624">
          <div className="rounded-2xl bg-navy-800 p-5" data-id="element-207" data-mp="2mu95sivw48lj">
            <p className="font-display text-[22px] font-black leading-tight" data-id="element-208" data-mp="2mvtye2yn9hgr">
              6 Specialized Clinical Volumes <span className="text-gold" data-id="element-209" data-mp="27zcprjhuagxw">+ 5 Exclusive Bonuses</span>
            </p>
            <p className="mt-2 text-[15px] text-white/75" data-id="element-210" data-mp="2cwl8bl6wgmzo">
              Everything you need to build a more structured approach to professional teeth whitening.
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-211" data-mp="b3wy2rvu8zae">
              {heroTopics.map(t => <li key={t.label} className="flex items-center gap-3 text-[15px] font-semibold" data-id="element-212" data-mp="1vm8uqha63t74">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand/20 text-brand-light" data-id="element-213" data-mp="1qopa8zmvmk6q">
                    <IconByName name={t.icon} className="h-4 w-4" data-id="element-214" data-mp="25eenht88uend" />
                  </span>
                  {t.label}
                </li>)}
            </ul>
          </div>

          <div className="mt-7" data-id="element-215" data-mp="2ec73kzlshqbt">
            <CtaButton id="hero-cta" label="Yes! I want the Dental Bleaching Blueprint™" sublabel="All 6 volumes + 5 bonuses for only $27 USD" data-id="element-216" data-mp="2efcumkdzb2a6" />
            <TrustRow tone="dark" items={["Instant Digital Access", "One-Time Payment", "Lifetime Access", "7-Day Guarantee"]} data-id="element-217" data-mp="2oby17a5nclg4" />
            <Countdown tone="dark" label="Special launch offer expires in:" data-id="element-218" data-mp="2jd4kl8v2cebq" />
            <CurrencyNote tone="dark" data-id="element-219" data-mp="typyyxfcd7kg" />
          </div>
        </div>
      </div>
    </header>;
}